import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { Link } from 'gatsby';

import Wrapper from '../../elements/wrapper';
import { media } from '../../helpers';

import TopWave from '../../../images/waves/home-top-wave.inline.svg';

const ContactWaveContainer = styled.div`
    position: relative;

    .banner-container {
        position: relative;
        max-width: 100vw;
        ${media.medium`max-width: 80vw;`};
        .image-container {
            margin-bottom: 10vh;
            ${media.medium`margin-bottom: 25vh;`};
            .gatsby-image-wrapper {
                min-height: 40vh;
            }
        }
        .content-container {
            ${media.medium`position: absolute;bottom: -7vh;left: 6vw;width: 100%;`}

            .inner-wrap {
                max-width: 450px;
                background-color: #f2f0eb;
                box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.12);
                padding: 50px 40px;
                margin: 0 auto;
                ${media.large`margin: 0;`}

                h3 {
                    font-size: 2rem;
                    color: #000;
                    margin: 0 0 20px;
                    font-weight: 800;
                    font-family: neue-kabel, sans-serif;
                }
                p {
                    font-size: 1.05rem;
                    line-height: 1.5;
                    color: #000;
                    font-weight: 800;
                    margin: 0 0 20px;
                    font-family: neue-kabel, sans-serif;

                    &.content {
                        color: #702716;
                        font-weight: 500;
                        font-family: sofia-pro, sans-serif;
                        margin-bottom: 0px;
                    }
                }
            }
        }
    }
`;

const ContactWave = ({ content }) => {
    const {
        bottomBannerImage,
        bottomBannerHeadline,
        bottomBannerAddress,
        bottomBannerCaption,
    } = content || {};
    function generateBannerContent() {
        return { __html: bottomBannerAddress };
    }
    return (
        <ContactWaveContainer>
            <Wrapper className="banner-container">
                <div className="image-container">
                    <Img
                        fluid={
                            bottomBannerImage.localFile.childImageSharp.fluid
                        }
                    />
                    <div className="content-container">
                        <div className="inner-wrap">
                            <h3>{bottomBannerHeadline}</h3>
                            <p>{bottomBannerCaption}</p>
                            <p
                                className="content"
                                dangerouslySetInnerHTML={generateBannerContent()}
                            ></p>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </ContactWaveContainer>
    );
};

export default ContactWave;
